import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Auth from "../../Auth/Auth";
import ConfirmActions from "../../Action/Actions/ConfirmActions";
import Translator from "../../Translation/Translator";

export default function* resendInviteMail(action: ActionInterface): any {
  try {
    yield call(Auth.resendInviteMail, action.payload);
    yield put(ConfirmActions.openPopup(Translator.trans("invite-email-sent")));
    yield put({type: Constants.LOADING_HIDE});

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
    yield put(ConfirmActions.resendInviteMailFailure(err));
    yield put(ConfirmActions.openPopup(err.translatedMessage));
  }
}

export function* watchResendInviteMail() {
  yield takeEvery(Constants.PAGE_CONFIRM_RESEND_INVITE_EMAIL_REQUEST, resendInviteMail);
}
